import React from "react";
import style from "./Footer.module.scss";

import { Link, useNavigate } from "react-router-dom";
import clsx from "clsx";

import Button from "components/shared/Button";
import WithPadding from "components/shared/WithPadding";

import LogoImg from "assets/images/logo.png";

// import FacebookImg from "assets/images/landing/facebook.png";
// import TwitterImg from "assets/images/landing/twitter.png";
// import YoutubeImg from "assets/images/landing/youtube.png";
// import InstaImg from "assets/images/landing/instagram.png";

import { BsTelephoneFill } from "react-icons/bs";
import { RiWhatsappFill } from "react-icons/ri";
import { BsLinkedin } from "react-icons/bs";
import { FaFacebook, FaInstagramSquare, FaYoutube } from "react-icons/fa";

// const images = [
//   {
//     img: <FaInstagramSquare size={34} style={{ marginTop: "-2px" }} />,
//     link: "https://www.instagram.com/hikewise_official/",
//   },
//   {
//     img: <BsLinkedin size={30} />,
//     link: "https://in.linkedin.com/company/vlead-eduventures",
//   },
// ];

const images = [
  {
    img: <FaFacebook size={30} />,
    link: 'https://www.facebook.com/careertestai',
  },
  {
    img: <FaInstagramSquare size={30} style={{ marginTop: '-2px' }} />,
    link: 'https://www.instagram.com/careertest.ai',
  },
  {
    img: <FaYoutube size={30} />,
    link: 'https://www.youtube.com/@careertestai',
  },
  {
    img: <BsLinkedin size={30} />,
    link: 'https://www.linkedin.com/company/careertestai',
  },
];

const Links1 = [
  // { name: "Class 8-9 Students", link: "/rise" },
  // { name: "Class 10-11-12 Students", link: "/sail" },
  // { name: "College Student/Graduates", link: "/redesign" },
  // { name: "Working Professionals", link: "/working-professionals" },
  // { name: "Certified Career Development Executive", link: "/ccde" },
  { name: 'CareerPedia', link: '/careerpedia' },
  // { name: "For Institutions", link: "/for-institutions" },
  { name: "Login", link: "/auth/login" },
  { name: "Sign Up", link: "/auth/register" },
];

const Links2 = [
  { name: "CareerTest for Institutions", link: "/for-institutions" },
  // { name: "About Us", link: "/about" },
  // { name: "Terms & Conditions", link: "/t&c" },
  // { name: "Privacy Policy", link: "/privacy-policy" },
  // { name: "Disclaimer", link: "/disclaimer" },
  // { name: "Contact Us", link: "/contact-us" },
];
const Links3 = [
  // { name: "CareerTest for Institutions", link: "/institutions" },
  { name: "About Us", link: "/about" },
  { name: "FAQs", link: "/faq" },
  { name: "Terms & Conditions", link: "/t&c" },
  { name: "Privacy Policy", link: "/privacy-policy" },
  { name: "Refund Policy", link: "/refund-policy" },
  { name: "Disclaimer", link: "/disclaimer" },
  { name: "Contact Us", link: "/contact-us" },
];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <div className={style.wrapper}>
      <WithPadding className={style.header}>
        <div className={style.left}>
          <div className={style.text}>
            <div>Got career-related doubts?</div>
            <div>Talk to our experts!</div>
          </div>
          <Button
            options={{ width: "160px", height: "40px" }}
            onClick={() => {
              navigate("/assessment/demo");
            }}
          >
            Take Free Demo
          </Button>
        </div>

        <div>
          <div className={clsx(style.text, style.textGray)}>
            <div>Call Us</div>
            <div>Feel free to reach out to us with anything you need</div>
          </div>
          <div className={clsx(style.socialHandles, style.buttons)}>
            <a href="tel:7593929394">
              <button class={style.btnTele}>
                <BsTelephoneFill size={15} />
                +91 7593929394
              </button>
            </a>

            <a href="https://wa.me/+7593929394" target="_blank" rel="noreferrer">
              <button className={style.btnWhatsapp}>
                <RiWhatsappFill size={18} />
                +91 7593929394
              </button>
            </a>
          </div>
        </div>

        {/* <div className={style.right}>
          <div className={clsx(style.text, style.textGray)}>
            <div>Stay Connected</div>
            <div>Stay updated with latest career trends and insights.</div>
          </div>
          <div className={style.socialHandles}>
            {images.map((image) => (
              <span
                onClick={() => {
                  window.open(image.link);
                }}
              >
                {image.img}
              </span>
            ))}
          </div>
        </div> */}
      </WithPadding>

      <WithPadding className={style.main}>
        <div className={clsx(style.logo, style.col)}>
          <div className={style.image}>
            <img src={LogoImg} alt="" />
          </div>
          {/* <div>© 2023 CareerTest | vLEAD </div>
          <div>Management</div>
          <div>Consultancy Private Limited</div> */}
          <div className={style.right}>
            <div className={clsx(style.text, style.textGray)}>
              <div>Follow us on</div>
            </div>
            <div className={style.socialHandles}>
              {images.map((image, index) => (
                <span
                  key={index}
                  onClick={() => {
                    window.open(image.link);
                  }}
                >
                  {image.img}
                </span>
              ))}
            </div>
            <div className={clsx(style.text, style.textGray)}>
              <div>© CareerTest 2025-26</div>
            </div>
          </div>
        </div>

        <div className={style.linksWrapper}>
          <div className={clsx(style.linksOne, style.col, style.links)}>
            <div className={style.heading}>For Individuals</div>
            {Links1.map(({ name, link }) => (
              <Link className={style.link} to={link}>
                {name}
              </Link>
            ))}
          </div>
          <div className={clsx(style.linksTwo, style.col, style.links)}>
          <div className={style.heading}>For Organizations</div>
            {Links2.map(({ name, link }) => (
              <Link className={style.link} to={link}>
                {name}
              </Link>
            ))}
          </div>
          <div className={clsx(style.linksThree, style.col, style.links)}>
          <div className={style.heading}>Quick Links</div>
            {Links3.map(({ name, link }) => (
              <Link className={style.link} to={link}>
                {name}
              </Link>
            ))}
          </div>
        </div>
      </WithPadding>

      <div className={style.hr}></div>
    </div>
  );
}
